import { render, staticRenderFns } from "./detalleNacionalFilters.vue?vue&type=template&id=1b5c053e"
import script from "./detalleNacionalFilters.vue?vue&type=script&lang=js"
export * from "./detalleNacionalFilters.vue?vue&type=script&lang=js"
import style0 from "./detalleNacionalFilters.vue?vue&type=style&index=0&id=1b5c053e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports